import { PlanShared } from './../../../general/shared/plan-shared';
import { PersonalAnalysticsService } from './../../../../data/repository/analytics-repository/personal-analystics.service';
import {
  FoodModel,
  FoodFactModel,
  FoodFactsModel,
} from './../../../../core/model/object/diet-food-model';
import { AddFoodBottomsheetComponent } from './../../add-food-bottomsheet/add-food-bottomsheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PersonalDataService } from './../../../../data/repository/plan-repository/personal-data.service';
import {
  personalFood,
  FoodFactCreate,
} from './../../../../core/model/api-response/persoanl-response-model';
import { PersoanlService } from './../../../../data/repository/plan-repository/persoanl.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';

@Component({
  selector: 'app-add-personal',
  templateUrl: './add-personal.component.html',
  styleUrls: ['./add-personal.component.scss'],
})
export class AddPersonalComponent implements OnInit {
  dietId: string;
  day: string;
  meal: string;
  persoanlFood: personalFood[] = [];
  isReady: boolean = false;

  constructor(
    private matBottomSheet: MatBottomSheet,
    private planService: PlanService,
    private route: ActivatedRoute,
    private persoanlService: PersoanlService,
    private personalDataService: PersonalDataService,
    private personalAnalysticsService: PersonalAnalysticsService,
    private planShared: PlanShared
  ) {
    this.day = this.route.snapshot.paramMap.get('day');
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.meal = this.route.snapshot.paramMap.get('meal');

    this.persoanlService.getAllFoodLogs().then((res) => {
      this.persoanlFood = res;
      this.isReady = true;
    });
    this.personalAnalysticsService.analyticVisitPersonalFood();
    if (
      !this.planShared.selectedMeal ||
      !this.planShared.selectedDietDayFoodLogs
    ) {
      this.back();
      return;
    }
  }

  ngOnInit() {}
  back() {
    this.planService.goBack();
  }
  goToAddFood() {
    this.planService.goToPersoanlFoodAdd(false);
  }
  goToEditFood(food: personalFood) {
    this.personalDataService.saveForEditFood(food);
    this.planService.goToPersoanlFoodAdd(true);
  }
  makeFoodFactsModel(f: FoodFactCreate): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
  openAndAddPersonalFood(data: personalFood) {
    const selectFood = new FoodModel(
      data._id,
      data.name,
      data.primaryFoodUnit,
      data.foodFact.calorieAmount,
      data.foodUnitRatioArray,
      data.foodFact,
      this.makeFoodFactsModel(data.foodFact)
    );
    this.matBottomSheet.open(AddFoodBottomsheetComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        food: selectFood,
        dietId: this.dietId,
        day: this.day,
        meal: this.meal,
        peronalFood: true,
      },
    });
  }
  gArr(i: number) {
    return new Array(i);
  }
}
